import { useEffect } from 'react'
// eslint-disable-next-line
export const useMountEffect = fun => useEffect(fun, [])
